import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent{

  title :string;
  ExceptionID:string="";
  supportUrl:string
  constructor(private router:Router,private commonDataService: CommonDataService) {
   }

  ngOnInit(): void {
    this.commonDataService.showLoader.next(false);
    this.title="An error occurred while processing your request!!";
    this.ExceptionID=history.state?.errorId;
    this.supportUrl=history.state?.url;
  }

}
